import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { RdsRegressionChartComponent } from './regression-chart.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [RdsRegressionChartComponent],
  declarations: [RdsRegressionChartComponent],
})
export class RdsRegressionChartModule {}
